<template>
  <div class="Aprojects-container">
    <section>
      <el-col class="toolbar">
        <h2>
          <em></em>
          <span>{{$t("admin.projects")}}</span>
        </h2>
      </el-col>

      <!--search-->
      <el-col :span="24" class="toolbar" style="margin-top: 60px;">
        <el-input
          :placeholder="$t('admin.searchProject')"
          icon="search"
          v-model="search"
          :on-icon-click="searchProject"
          @keyup.enter.native="searchProject"
        ></el-input>
      </el-col>
      <!-- user -->
      <div class="seaBox">
        <ul class="seaBUl" v-if="user.role">
          <li>
            <span class="seaUTit">{{$t("accountInfo.username")}}:</span>
            <span class="seaUTex">{{user.username}}</span>
          </li>
          <li>
            <span class="seaUTit">{{$t("accountInfo.email")}}:</span>
            <span class="seaUTex">{{user.email}}</span>
          </li>
          <li>
            <span class="seaUTit">{{$t("accountInfo.role")}}:</span>
            <span class="seaUTex">{{user.role}}</span>
          </li>
          <!-- <li>
            <span class="seaUTit">{{$t("accountInfo.level")}}:</span>
            <span class="seaUTex">{{user.level}}</span>
          </li>-->
          <li>
            <span class="seaUTit">{{$t("accountInfo.status")}}:</span>
            <span class="seaUTex">{{user.status}}</span>
          </li>
        </ul>
      </div>
      <div class="project-container">
        <!--projects-->
        <el-table
          :data="projects"
          :empty-text="$t('common.noData')"
          highlight-current-row
          v-loading="listLoading"
          min-width="100%"
        >
          <el-table-column prop="name" :label="$t('projectManage.name')" min-width="15%"></el-table-column>
          <el-table-column prop="apikey" :label="$t('projectManage.apikey')" min-width="25%">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row.apikey}}</div>
                <p class="keyP">{{scope.row.apikey}}</p>
              </el-tooltip>
              <div @click="copy('apikey', scope.row)" class="tag"></div>
            </template>
          </el-table-column>
          <el-table-column prop="secret" :label="$t('projectManage.secret')" min-width="25%">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row.secret}}</div>
                <p class="keyP">{{scope.row.secret}}</p>
              </el-tooltip>
              <div @click="copy('secret', scope.row)" class="tag"></div>
            </template>
          </el-table-column>
          <el-table-column prop="created" :label="$t('projectManage.createDate')" min-width="15%"></el-table-column>
          <el-table-column :label="$t('common.operation')" min-width="15%">
            <template scope="scope">
              <el-switch
                on-value="normal"
                off-value="disabled"
                v-model="scope.row.status"
                on-color="#13ce66"
                off-color="#cdcdcd"
                @change="setProject(scope.row)"
              ></el-switch>
              <el-button
                type
                size="small"
                @click="projectStats(scope.row.apikey)"
                style="margin: 0 0 0 20px;"
              >{{$t("stats.title")}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../../api/api";
import { resCode, pattern } from "../../../server/common/data";
import { formatTime } from "../../common/utils";
import Clipboard from "clipboard";

export default {
  data() {
    return {
      search: "",
      user: {},
      projects: [],
      listLoading: false
    };
  },
  // created() {
  //   console.log(this.$route.params.username);
  // },
  methods: {
    // echarts
    projectStats(apikey) {
      this.$router.push({
        name: "Statistics",
        params: {apikey: apikey, username: this.user.username, uid: this.user.uid}
      });
    },
    // normal/disabled
    setProject(project) {
      api
        .setProject({
          apikey: project.apikey,
          status: project.status
        })
        .then(res => {
          // this.listLoading = false;
        })
        .catch(() => {});
    },
    // copy
    copy(column, data) {
      let clipboard = new Clipboard(".tag", {
        text: function() {
          if (column === "apikey") {
            return data.apikey;
          } else {
            return data.secret;
          }
        }
      });
      clipboard.on("success", e => {
        this.$message({message: this.$t("common.copySuccess"), showClose: true,  type: "success"});
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        this.$message({message: this.$t("common.copyFailed"), showClose: true, type: "error"});
        clipboard.destroy();
      });
    },
    // search
    searchProject(key) {
      api
        .search({
          key: this.search
        })
        .then(res => {
          if (res.data.CODE === resCode.SUCCESS) {
            this.user = res.data.DATA.user;
            this.user.created = formatTime(
              this.user.created,
              "YYYY-MM-DD HH:mm:ss"
            );
            if (this.user.status === "disabled") {
              this.user.status = this.$t("common.statusDisabled");
            } else {
              this.user.status = this.$t("common.statusNormal");
            }
            this.projects = res.data.DATA.projects;
            this.projects.forEach(item => {
              item.created = formatTime(item.created, "YYYY-MM-DD HH:mm:ss");
            });
          } else {
            this.user = {};
            this.projects = [];
          }
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.search = this.$route.params.username;
    if (this.search) {
      this.searchProject(this.search);
    }
  }
};
</script>

<style lang="scss">
.el-table__body {
  width: 100% !important;
}
.Aprojects-container {
  width: 99%;
  table {
    border: none !important;
    .el-button {
      border: none;
      color: #e7bd62;
      font-size: 14px;
      border-radius: 13px;
      background: #fff0;
    }
    .el-button:focus,
    .el-button:hover {
      color: #fff !important;
    }
  }
  .project-container {
    width: 99%;
    // height: 480px;
    margin: 30px 10px 0;
    display: inline-block;
    border: none;
    border: 1px solid #e2e2e2;
    .el-table {
      border: none !important;
      .el-table th {
        background-color: #f4f7f9 !important;
      }
      tr:nth-child(even) {
        background-color: #f4f7f9 !important;
      }
      tr {
        border-radius: 8px;
        th {
          height: 46px;
          border: none;
        }
        td {
          height: 46px;
          border: none;
        }
      }
      .el-table__column-resize-proxy {
        border: none;
      }
    }
  }
  .seaBox {
    margin: 140px 0 0 0px;
    .seaBUl {
      li {
        float: left;
        list-style: none;
        margin: 0 30px 0 13px;
        .seaUTit {
          font-weight: bold;
          font-size: 14px;
        }
        .seaUTex {
          font-size: 14px;
        }
      }
    }
  }
  .keyP {
    float: left;
    width: 93%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tag {
    // float: left;
    width: 16px;
    height: 14px;
    display: inline-block;
    background: url("../../assets/copy.png") no-repeat center center;
    background-size: contain;
    vertical-align: middle;
  }
  .tag:hover {
    background: url("../../assets/copy1.png") no-repeat center center;
    background-size: contain;
    vertical-align: middle;
    cursor: pointer;
  }
  .el-table__body-wrapper {
    overflow: unset;
    position: relative;
  }
  .el-table:after,
  .el-table:before {
    content: "";
    position: absolute;
    background-color: #f8f9fa;
    z-index: 1;
  }
}
</style>


// WEBPACK FOOTER //
// Projects.vue?a6b82e22